import { races as srdRaces } from './races';
import { ignusRaces } from '../rulesets/ignus';

/**
 * Combined races from all sources.
 * The ruleset-aware getters filter this by source.
 */
export const races = [...srdRaces, ...ignusRaces];

// Re-export for backwards compatibility
export { srdRaces };
